import $ from "jquery";

export default {
  contains: function (list, value) {
    return list.indexOf(value) !== -1;
  },
  containsOneOf: function (list, values) {
    return values.some(function (value) {
      return list.indexOf(value) !== -1;
    });
  },
  isEmpty: function (arg) {
    return !arg || arg.length === 0;
  },
  nonEmpty: function (arg) {
    return arg && arg.length !== 0;
  },
  notNaN: function notNaN(number) {
    return !isNaN(number);
  },
  notNull: function (value) {
    return value !== null;
  },
  trim: function (string) {
    return string.trim();
  },
  find: function (array, closure) {
    var item = null;
    return array.some(function (iteration) {
      return closure(item = iteration);
    }) ? item : null;
  },
  $target: function (event) {
    return $(event.target);
  },
  $originalTarget: function (event) {
    return $(event.originalTarget ? event.originalTarget : event.srcElement);
  },
  $currentTarget: function (event) {
    return $(event.currentTarget);
  },
  $targetValue: function (event) {
    return $(event.target).val();
  },
  $targetParent: function (event) {
    return $(event.target).parent();
  },
  isTrue: function (arg) {
    return arg === true;
  },
  isFalse: function (arg) {
    return arg === false;
  },
  not: function (f) {
    return function (arg) {
      return !f(arg);
    };
  },
  isChecked: function (event) {
    return $(event.target).is(":checked");
  },
  isNotDisabled: function (event) {
    return $(event.target).attr("disabled") !== "disabled";
  },
  isArray: function (arg) {
    return $.isArray(arg);
  },
  asInt: function (value) {
    return window.parseInt(value, 10);
  },
  asIntArray: function (valueArray) {
    if (valueArray) {
      return valueArray.split(",").map(function (item) {
        return window.parseInt(item, 10);
      });
    } else {
      return [];
    }
  },
  getDataId: function (element) {
    return window.parseInt(element.getAttribute("data-id"), 10);
  },
  self: function (value) {
    return value;
  },
  stopEvent: function (event) {
    event.preventDefault();
    event.stopPropagation();
  },
  removeItem: function (array, item) {
    var index = array.indexOf(item);
    if (index !== -1) {
      array.splice(index, 1);
    }
  },
  setup: function (callback) {
    var initialized = false;
    return function () {
      if (!initialized) {
        callback.apply(this, arguments);
        initialized = true;
      }
    };
  },
  subscribe: function () {
  }, // bacon properties do not register value unless there at least one subscriber present
  toggleClass: function (selector, className) {
    return function (state) {
      $(selector).toggleClass(className, state);
    };
  },
  querySelectorArray: function (selector) {
    return [].slice.call(document.querySelectorAll(selector), 0);
  },
  isElementInViewport: function (el) {
    if (el instanceof $) {
      el = el[0];
    }

    var rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    );
  },
  equals: function (expected) {
    return function (val) {
      return val === expected;
    };
  },
  removeWhiteSpace: function (arg) {
    return arg.replace(/ /g, '');
  },
  pixelsInRem: function (pixels) {
    return pixels / 10;
  },
  pixelsInRemString: function (pixels) {
    return this.pixelsInRem(pixels) + 'rem';
  },
  getElementDistanceFromTop: function (selector) {
    var $elem = $(selector);
    return Math.max(0, $elem.offset().top - $(window).scrollTop() + $elem.height());
  }
};



// WEBPACK FOOTER //
// ./web/js/common.js